<template>
  <div class="fixed z-999 right-5 top-60">
    <el-button circle class="w-14 h-14 btn-primary" type="primary" size="large" @click="$router.push('/product/myCart')">
      <i class="el-icon-shopping-cart-full text-3xl" />
    </el-button>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
